/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Region_LabelInputs */

const en_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Region`)
};

const fr_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone de numérisation`)
};

const de_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanbereich`)
};

const it_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regione di scansione`)
};

const ru_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Область сканирования`)
};

const es_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Región de escaneo`)
};

const zh_cn2_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描区域`)
};

const ja_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキャン領域`)
};

const hi_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कैन क्षेत्र`)
};

const pt_pt2_ocr_crop_region_label = /** @type {(inputs: Ocr_Crop_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Região de digitalização`)
};

/**
* | output |
* | --- |
* | "Scan Region" |
*
* @param {Ocr_Crop_Region_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_region_label = /** @type {((inputs?: Ocr_Crop_Region_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Region_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_region_label(inputs)
	if (locale === "de") return de_ocr_crop_region_label(inputs)
	if (locale === "it") return it_ocr_crop_region_label(inputs)
	if (locale === "ru") return ru_ocr_crop_region_label(inputs)
	if (locale === "es") return es_ocr_crop_region_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_region_label(inputs)
	if (locale === "ja") return ja_ocr_crop_region_label(inputs)
	if (locale === "hi") return hi_ocr_crop_region_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_region_label(inputs)
	return en_ocr_crop_region_label(inputs)
});